const U = 'https://images.unsplash.com/photo-';

export const TEMPLATES = [
  {
    id:'restaurant-v1', label:'Restaurant & Food', category:'Hospitality', icon:'🍽️',
    demoUrl:'https://chamcore.com/projects/restaurant/', accent:'#f97316', accentGlow:'rgba(249,115,22,.25)',
    tagline:'Online ordering, bookings & menu management',
    tags:['Restaurants','Cafés','Takeaway'],
    photoUrl:`${U}1414235077428-338989a2e8c0?auto=format&fit=crop&w=600&q=80`,
    personUrl:`${U}1494790108377-be9c29b29330?auto=format&fit=crop&w=80&q=80`,
    personName:'Sofia M.', personRole:'Bella Ristorante, Oslo',
  },
  {
    id:'salon-v1', label:'Hair & Beauty Salon', category:'Wellness', icon:'💇',
    demoUrl:'https://chamcore.com/projects/salon/', accent:'#ec4899', accentGlow:'rgba(236,72,153,.25)',
    tagline:'Appointments, gallery & team profiles',
    tags:['Hair salons','Beauty','Nail studios'],
    photoUrl:`${U}1560066984-138daef929c0?auto=format&fit=crop&w=600&q=80`,
    personUrl:`${U}1438761681033-6461ffad8d80?auto=format&fit=crop&w=80&q=80`,
    personName:'Emma K.', personRole:'Glamour Studio, Bergen',
  },
  {
    id:'legal-v1', label:'Law & IVR Services', category:'Professional', icon:'⚖️',
    demoUrl:'https://teletorget.com', accent:'#3b82f6', accentGlow:'rgba(59,130,246,.25)',
    tagline:'Case intake, IVR call routing & client portal',
    tags:['Law firms','Consultants','IVR services'],
    photoUrl:`${U}1589829545856-d10d557cf95f?auto=format&fit=crop&w=600&q=80`,
    personUrl:`${U}1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=80&q=80`,
    personName:'Anders B.', personRole:'Advokatfirma Brekke, Oslo',
  },
  {
    id:'corporate-v1', label:'Corporate / Agency', category:'Corporate', icon:'🏢',
    demoUrl:'https://chamcore.com/', accent:'#818cf8', accentGlow:'rgba(129,140,248,.25)',
    tagline:'Lead capture, sales portal & investor deck',
    tags:['Agencies','Startups','Enterprises'],
    photoUrl:`${U}1497366216548-37526070297c?auto=format&fit=crop&w=600&q=80`,
    personUrl:`${U}1472099645785-5658abf4ff4e?auto=format&fit=crop&w=80&q=80`,
    personName:'Lars T.', personRole:'TechVentures AS, Oslo',
  },
];

export const TEMPLATE_CATEGORIES = [
  {
    id:'food', icon:'🍽️', label:'Food & Hospitality',
    sub:'Restaurants, cafés, takeaways & catering',
    templates:[
      { id:'restaurant-v1', label:'Restaurant', icon:'🍽️', photoUrl:`${U}1414235077428-338989a2e8c0?auto=format&fit=crop&w=400&q=80`, accent:'#f97316' },
      { id:'cafe-v1',       label:'Café',       icon:'☕', photoUrl:`${U}1501339847302-ac426a4a7cbb?auto=format&fit=crop&w=400&q=80`, accent:'#d97706' },
      { id:'pizza-v1',      label:'Pizza',      icon:'🍕', photoUrl:`${U}1513104890138-7c749659a591?auto=format&fit=crop&w=400&q=80`, accent:'#dc2626' },
      { id:'asian-v1',      label:'Asian Cuisine', icon:'🍜', photoUrl:`${U}1569050467447-ce54b3bbc37d?auto=format&fit=crop&w=400&q=80`, accent:'#b45309' },
    ],
  },
  {
    id:'wellness', icon:'💆', label:'Health & Wellness',
    sub:'Salons, spas, nail studios & barbershops',
    templates:[
      { id:'salon-v1',  label:'Hair Salon', icon:'💇', photoUrl:`${U}1560066984-138daef929c0?auto=format&fit=crop&w=400&q=80`, accent:'#ec4899' },
      { id:'spa-v1',    label:'Spa',        icon:'🧖', photoUrl:`${U}1540555700478-4be290a8b731?auto=format&fit=crop&w=400&q=80`, accent:'#8b5cf6' },
      { id:'nails-v1',  label:'Nail Studio',icon:'💅', photoUrl:`${U}1604654894610-df63bc536371?auto=format&fit=crop&w=400&q=80`, accent:'#f43f5e' },
      { id:'barber-v1', label:'Barbershop', icon:'✂️', photoUrl:`${U}1503951914875-452162b0f3f1?auto=format&fit=crop&w=400&q=80`, accent:'#0891b2' },
    ],
  },
  {
    id:'professional', icon:'💼', label:'Professional Services',
    sub:'Law firms, consultancies, clinics & accounting',
    templates:[
      { id:'legal-v1',      label:'Law Firm',    icon:'⚖️', photoUrl:`${U}1589829545856-d10d557cf95f?auto=format&fit=crop&w=400&q=80`, accent:'#3b82f6' },
      { id:'consult-v1',    label:'Consultant',  icon:'💡', photoUrl:`${U}1454165804606-c3d57bc86b40?auto=format&fit=crop&w=400&q=80`, accent:'#0ea5e9' },
      { id:'clinic-v1',     label:'Clinic',      icon:'🏥', photoUrl:`${U}1519494026892-476f3fae6f6e?auto=format&fit=crop&w=400&q=80`, accent:'#10b981' },
      { id:'accounting-v1', label:'Accounting',  icon:'📊', photoUrl:`${U}1554224155-8d04cb21cd6c?auto=format&fit=crop&w=400&q=80`, accent:'#6366f1' },
    ],
  },
  {
    id:'corporate', icon:'🏢', label:'Corporate & Digital',
    sub:'Agencies, startups, shops & event companies',
    templates:[
      { id:'corporate-v1', label:'Corporate',  icon:'🏢', photoUrl:`${U}1497366216548-37526070297c?auto=format&fit=crop&w=400&q=80`, accent:'#818cf8' },
      { id:'startup-v1',   label:'Startup',    icon:'🚀', photoUrl:`${U}1559136555-9303baf1ae6b?auto=format&fit=crop&w=400&q=80`, accent:'#6366f1' },
      { id:'shop-v1',      label:'Online Shop',icon:'🛍️', photoUrl:`${U}1472851294608-062f824d29cc?auto=format&fit=crop&w=400&q=80`, accent:'#f59e0b' },
      { id:'event-v1',     label:'Events',     icon:'🎉', photoUrl:`${U}1492684223066-81342ee5ff30?auto=format&fit=crop&w=400&q=80`, accent:'#ec4899' },
    ],
  },
];

export const TESTIMONIALS = [
  {
    name:'Sofia M.', role:'Bella Ristorante, Oslo',
    avatar:`${U}1494790108377-be9c29b29330?auto=format&fit=crop&w=80&q=80`,
    accent:'#f97316',
  },
  {
    name:'Emma K.', role:'Glamour Studio, Bergen',
    avatar:`${U}1438761681033-6461ffad8d80?auto=format&fit=crop&w=80&q=80`,
    accent:'#ec4899',
  },
  {
    name:'Anders B.', role:'Advokatfirma Brekke, Oslo',
    avatar:`${U}1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=80&q=80`,
    accent:'#3b82f6',
  },
];

export const PROOF_AVATARS = [
  `${U}1494790108377-be9c29b29330?auto=format&fit=crop&w=40&q=80`,
  `${U}1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=40&q=80`,
  `${U}1438761681033-6461ffad8d80?auto=format&fit=crop&w=40&q=80`,
  `${U}1472099645785-5658abf4ff4e?auto=format&fit=crop&w=40&q=80`,
  `${U}1500648767791-00dcc994a43e?auto=format&fit=crop&w=40&q=80`,
];

// Restaurant concept data for the live preview in Step 5
export const RESTAURANT_CONCEPTS = {
  thai: {
    name: 'Orchid Thai',
    tagline: 'Authentic Thai cuisine',
    heroImg: `https://images.unsplash.com/photo-1559314809-0d155014e29e?auto=format&fit=crop&w=1200&q=80`,
    menu: [
      { name:'Pad Thai', desc:'Rice noodles, egg, bean sprouts', price:'Kr 179', img:`https://images.unsplash.com/photo-1559314809-0d155014e29e?auto=format&fit=crop&w=300&q=80` },
      { name:'Green Curry', desc:'Coconut milk, bamboo shoots', price:'Kr 189', img:`https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?auto=format&fit=crop&w=300&q=80` },
      { name:'Tom Yum Soup', desc:'Lemongrass, mushrooms, lime', price:'Kr 149', img:`https://images.unsplash.com/photo-1569050467447-ce54b3bbc37d?auto=format&fit=crop&w=300&q=80` },
    ],
  },
  pizza: {
    name: 'Napoli Express',
    tagline: 'Wood-fired Italian pizza',
    heroImg: `https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=1200&q=80`,
    menu: [
      { name:'Margherita', desc:'Tomato, mozzarella, basil', price:'Kr 169', img:`https://images.unsplash.com/photo-1574071318508-1cdbab80d002?auto=format&fit=crop&w=300&q=80` },
      { name:'Pepperoni', desc:'Tomato, mozzarella, pepperoni', price:'Kr 189', img:`https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=300&q=80` },
      { name:'Quattro Stagioni', desc:'Ham, mushrooms, olives, artichoke', price:'Kr 199', img:`https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?auto=format&fit=crop&w=300&q=80` },
    ],
  },
};
